// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import getNewModulationCountByModulationSchemeDescription from './getNewModulationCountByModulationSchemeDescription'

// because the only thing that makes a modulation unique (even at the radio level) is the radioModulationId
// we cannot determine which new modulation threw an error between two brand new modulations which are using the same modulation scheme
// as a result, we add a check where, if more than one new modulation is using the same modulation scheme as a new modulation
// that threw an error we tell the user: we think this modulation threw the error but it might have been this other modulation too.
// based on the error message and the data they input, the user will be able to determine which modulation actually threw the error
// and how to fix it.

const getNewModulationErrorMessages = (modulationErrorFromRadioDetails, modulationSchemeDescription) => dispatch => {
  const messages = [...modulationErrorFromRadioDetails.messages]

  const newModulationsWithSameModulationSchemeDescriptionCount = (
    dispatch(getNewModulationCountByModulationSchemeDescription(modulationSchemeDescription))
  )

  if (newModulationsWithSameModulationSchemeDescriptionCount === 2) {
    messages.unshift('This error could be generated from 1 other new modulation which uses the same Modulation Scheme.')
  } else if (newModulationsWithSameModulationSchemeDescriptionCount > 2) {
    messages.unshift(`This error could be generated from ${newModulationsWithSameModulationSchemeDescriptionCount - 1} other new modulations which use the same Modulation Scheme.`)
  }

  return messages
}

export default getNewModulationErrorMessages
